/// Port of mobile/lib/game/sky/day_sky.dart.

import { Component } from '../engine/component';
import type { Rng } from '../engine/random';
import { CloudManager } from './cloud';
import { Sun } from './sun';

/// Light-mode sky: fixed sun + drifting clouds.
export class DaySky extends Component {
  readonly sun: Sun;
  readonly clouds: CloudManager;

  constructor(deps: {
    allowsAmbientMotion: () => boolean;
    currentSpeed: () => number;
    rng?: Rng;
  }) {
    super(-1);
    this.sun = new Sun();
    this.clouds = new CloudManager(deps);
    this.add(this.sun);
    this.add(this.clouds);
  }

  reset(): void {
    this.clouds.reset();
  }
}
